import React, { useMemo } from "react";
import { Button } from "../../../Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogHeader,
} from "../../../dialog";
import { Grid } from "../../../Grid";
import { Select } from "../../../Select";

export type SelectedDevices = {
  audioDevice?: MediaDeviceInfo;
};

type Props = {
  localizations?: {
    audioInput?: string;
    settings?: string;
    ok?: string;
  };
  availableDevices: MediaDeviceInfo[];
  selectedDevices: SelectedDevices;
  onInputChange: (selectedDevices: SelectedDevices) => void;
  onAcceptClick: () => void;
};

export function SettingsModal({
  localizations,
  availableDevices,
  selectedDevices,
  onInputChange,
  onAcceptClick,
}: Props) {
  const audioInputDevices = useMemo(
    () => availableDevices.filter((device) => device.kind === "audioinput"),
    [availableDevices]
  );

  const onAudioInputChange = (value: string) => {
    const device = availableDevices.find((device) => device.deviceId === value);

    onInputChange({ audioDevice: device });
  };

  return (
    <Dialog open fullWidth onClose={onAcceptClick}>
      <DialogHeader onClose={onAcceptClick}>
        {localizations?.settings ?? "Settings"}
      </DialogHeader>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Select
              label={localizations?.audioInput ?? "Audio Input"}
              options={audioInputDevices}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.deviceId}
              value={selectedDevices.audioDevice?.deviceId}
              onChange={(value) => onAudioInputChange(value as string)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          text={localizations?.ok ?? "Ok"}
          align="center"
          onClick={onAcceptClick}
        />
      </DialogActions>
    </Dialog>
  );
}
